import { map } from 'rxjs/operators';
import {
    fetchProductCategories,
    fetchProductGroups,
    fetchProducts,
    updateProduct
} from '../../../features/product/redux/productSlices';
import { ProductDto } from '../../PricePrgClient';
import { hubListener, hubNotifier, signalROptions } from '../helpers';
import { notifyProductUpdated } from '../signalrActions';
import { SignalrHub } from '../signalrTypes';

export const productHub: SignalrHub = {
    hubName: 'product hub',
    url: '/signalr/productHub',
    autoReconnect: true,
    options: signalROptions
};

const productHub$ = hubListener(productHub, hub => {
    const productsUpdated$ = hub.on<void>('ProductsUpdated').pipe(map(fetchProducts.request));

    const productCategoriesUpdated$ = hub
        .on<void>('ProductCategoriesUpdated')
        .pipe(map(fetchProductCategories.request));

    const productGroupsUpdated$ = hub.on<void>('ProductGroupsUpdated').pipe(map(fetchProductGroups.request));

    const productUpdated$ = hub
        .on<ProductDto>('ProductUpdated')
        .pipe(map(p => updateProduct.success({ dto: { ...p }, productId: p.productId })));

    return [productsUpdated$, productCategoriesUpdated$, productGroupsUpdated$, productUpdated$];
});

const notifyProductUpdated$ = hubNotifier(productHub, notifyProductUpdated, (hub, payload) =>
    hub.send('NotifyProductUpdated', payload)
);

export default [productHub$, notifyProductUpdated$];
